/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular-rpk/core';
import { DxoVectorMapProjectionConfig } from './base/vector-map-projection-config';


@Component({
    selector: 'dxo-projection',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'aspectRatio',
        'from',
        'to'
    ]
})
export class DxoProjectionComponent extends DxoVectorMapProjectionConfig implements OnDestroy, OnInit  {

    protected get _optionPath() {
        return 'projection';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoProjectionComponent
  ],
  exports: [
    DxoProjectionComponent
  ],
})
export class DxoProjectionModule { }
